<div>
  <div class="build-your-profile-title guts-p-b-1-half">
    <h3 class="h3">{{ 'dgProfileOverview_BuildProfileTitle' | translate }}</h3>
    <p class="par--light_a par--small">
      {{ 'dgProfileOverview_BuildProfileSubTitle' | translate }}
    </p>
  </div>

  <div *ngIf="hasResumeParsing" class="guts-p-b-1-half">
    <dgx-parsed-resume-indicator
      [hasParsedResume]="hasParsedResume"
      [ownerKey]="ownerKey"
    ></dgx-parsed-resume-indicator>
  </div>

  <div class="build-your-profile-section-nav">
    <ul>
      <ng-container
        *ngFor="
          let section of config;
          trackBy: trackByConfigId;
          let first = first;
          let last = last;
          index as sectionIndex
        "
        data-dgat="build-your-profile-445"
        ><li
          class="build-your-profile-section-nav__item guts-p-h-1-half"
          [ngClass]="{
            'build-your-profile-section-nav__item--border-bottom': !last,
            'guts-p-t-1-half': first
          }"
        >
          <!-- Vertical line spacer added to top of all sections but the first one -->
          <div
            class="
              build-your-profile-section-nav__vertical-line
              build-your-profile-section-nav__vertical-line--spacer-top
            "
            *ngIf="sectionIndex > 0"
          ></div>
          <div
            class="
              l_flex
              build-your-profile-section-nav__vertical-line
              build-your-profile-section-nav__section-menu
            "
            [ngClass]="{
              'build-your-profile-section-nav__section-menu--last': last
            }"
          >
            <div
              class="
                l_flex
                build-your-profile-section-nav__section-menu--progress-items
              "
              [attr.aria-label]="
                section.progress < 100
                  ? section.copy + i18n.Core_Completion_Progress
                  : section.copy +
                    i18n.dgProfileOverview_BuildProfileSectionCompleted
              "
            >
              <dgx-progress-circle
                *ngIf="section.progress < 100"
                [percent]="section.progress"
                [config]="{
                  color: progressCircleInProgress,
                  bgcolor: progressCircleTrailColor,
                  radius: 8
                }"
              ></dgx-progress-circle>
              <img
                [attr.aria-label]="
                  i18n.dgProfileOverview_BuildProfileSectionCompleted
                "
                [src]="completedImg | blobifyUrl: true"
                *ngIf="section.progress === 100"
              />
              <p class="par par--small par--light_a guts-p-l-1 no-wrap">
                {{ section.copy }}
              </p>
            </div>
          </div>
          <div
            class="
              build-your-profile-section-nav__vertical-line
              build-your-profile-section-nav__vertical-line--spacer-bottom
            "
            *ngIf="!last"
          ></div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
